<script>
import Label from "../form-components/Label.vue";
import Multiselect from "vue-multiselect";

export default {
  props: {
    item_key: {
      type: String,
      required: false,
    },
    item_value: {
      // type: String,
      required: false,
    },
    item: {
      type: Object,
      required: false,
    },
    submitted: {
      type: Boolean,
      required: false,
    },
    validation: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true
    }
  },
  components: {
    Label,
    Multiselect,
  },
  data() {
    return {
      value: null,
      options: [],
      label: {
        label: 'Group',
        placeholder: 'Select Group'
      }
    };
  },
  watch: {
    value(val) {
        this.updateValue(val)
    },
  },
  methods: {
    async getOptions() {
      this.options = ['Patient Info', 'Policies', 'About Us']
      if(this.options && this.options.length) this.value = this.options[0]
    },
  },
  mounted() {
    this.getOptions();
  },
};
</script>
<template>
  <div class="mb-3">
    <Label :item="label"/>
    <multiselect
      v-model="value"
      :options="options"
      :searchable="options.length > 5 ? true : false"
      :close-on-select="true"
      :show-labels="false"
      :placeholder="'Select Group'"
      :allow-empty="false"
      :preselectFirst="true"
      open-direction="bottom"
    >
      <template slot="singleLabel" slot-scope="{ option }"
        ><strong>{{ option }}</strong></template
      >
    </multiselect>
  </div>
</template>